<!--<div class="flex-col w-full pt-[26px] sm:pt-[48px]">-->
<!--&lt;!&ndash;  class="flex px-[36px] sm:px-[120px]"&ndash;&gt;-->
<!--  <section [ngClass]="[currentScreenSize() === 'SM' ? 'mx-[35px]' : currentScreenSize() === 'MD' ? 'ml-[47px] mr-[44px]' : 'ml-[113px] mr-[120px]', 'flex flex-col mb-[50px]']">-->
<!--&lt;!&ndash;    class="grid grid-cols-1 sm:grid-cols-[auto_auto] w-full  pb-[15px] sm:pb-[25px] items-end sm:items-center"&ndash;&gt;-->
<!--    <div [ngClass]="[currentScreenSize() === 'SM' ? 'grid-cols-1 items-end' : 'grid-cols-[auto_auto] pb-[25px] items-start', 'grid w-full pb-[15px]']">-->
<!--      <div class="flex justify-start text-cafe text-xl sm:text-2xl font-medium font-['Roboto']">-->
<!--        Productos que fueron creados y vendidos por nuestros diseñadores y artesanos-->
<!--      </div>-->
<!--      <button class="flex justify-end items-start text-base font-medium sm:text-lg font-['Roboto'] text-verde">-->
<!--        <button class="hover:underline" (click)="navigateToAllArtisansProducts()">Ver todo</button>-->
<!--      </button>-->
<!--    </div>-->
<!--  </section>-->
<!--&lt;!&ndash;  Carrusel de productos&ndash;&gt;-->
<!--&lt;!&ndash;class="pb-[26px] sm:pb-[48px] px-[34px] sm:px-[85.5px] overflow-x-hidden"&ndash;&gt;-->
<!--  <div [ngClass]="[currentScreenSize() === 'SM' ? 'px-[32.5px] pb-[48px]' : currentScreenSize() === 'MD' ? 'pl-[20px] pr-[17px]' : 'pl-[79px] pr-[86px]', 'overflow-x-hidden']">-->
<!--    @if(gettingProducts()) {-->
<!--      <div class="w-full">-->
<!--        <ln-skeleton [mediaClass]="'aspect-square h-[275px] rounded-xl bg-slate-200 dark:bg-verde w-full'"-->

<!--        ></ln-skeleton>-->
<!--      </div>-->

<!--    } @else {-->
<!--      <ln-products-carousel [products]="products" [showProductsPrice] = false></ln-products-carousel>-->
<!--    }-->
<!--  </div>-->

<!--</div>-->

<div class="flex-col w-full pt-[26px] sm:pt-[48px]">
  <section class="flex px-[36px] sm:px-[120px]">
    <div class="grid grid-cols-1 sm:grid-cols-[auto_auto] w-full  pb-[15px] sm:pb-[25px] items-end sm:items-center">
      <div class="flex justify-start text-cafe text-xl sm:text-2xl font-medium font-['Roboto']">
        {{'components.ArtisansDesignersCreatedProductsComponent.title' | transloco}}
      </div>
      @if(showSeeMore()) {
        <button class="flex justify-end text-base font-medium sm:text-lg font-['Roboto'] text-verde">
          <button class="hover:underline" (click)="navigateToAllArtisansProducts()">{{'components.ArtisansDesignersCreatedProductsComponent.seeAll' | transloco}}</button>
        </button>
      }

    </div>
  </section>
  <!--  Carrusel de productos-->

  <div class="pb-[26px] sm:pb-[48px] px-[34px] sm:px-[85.5px] overflow-x-hidden">
    @if(gettingProducts()) {
      <div class="w-full">
        <ln-skeleton [mediaClass]="'aspect-square h-[275px] rounded-xl bg-slate-200 dark:bg-verde w-full'"

        ></ln-skeleton>
      </div>

    } @else {
      <ln-products-carousel [products]="products" [showProductsPrice] = false></ln-products-carousel>
    }
  </div>

</div>
